// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "分析化学",
      "tec": "田甜",
      "week": "1-6,8-15周",
      "add": "实训楼F座301信息"
    },
    {
      "sub": "大学物理（下)",
      "tec": "杜春艳",
      "week": "1-6,8-15周",
      "add": "教学楼A座321电力"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-6,8,11-15周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "白波",
      "week": "1-4周",
      "add": "教学楼D座120新能"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "大学英语（三）",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25新能源1-3",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "教学楼A座125信息"
      },
      {
        "sub": "25新能源1-2",
        "tec": "文菲",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25新能源2-1",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      }
    ],
    {
      "sub": "概率论与数理统计",
      "tec": "马婷婷",
      "week": "1-6,8-17周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "无机化学（二）",
      "tec": "李珊珊",
      "week": "1-6,8-12周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "创造性思维与创新方法",
      "tec": "田甜",
      "week": "1-6,8-17周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "1-4周",
      "add": "教学楼C座311教务"
    }
  ],
  "3": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-6,8,11-15周",
      "add": "教学楼B座425能动"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "傅瑶",
      "week": "1-6,8-17周",
      "add": "教学楼A座422机械"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "无机化学（二）",
      "tec": "李珊珊",
      "week": "1,3,5,9,11周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "大学物理（下)",
      "tec": "杜春艳",
      "week": "1-6,8-15周",
      "add": "教学楼A座321电力"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女乒",
        "tec": "李罡",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "足球",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "足球",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女网",
        "tec": "张慧",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "健美操",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男篮",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男篮",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女排",
        "tec": "李莉",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "女羽",
        "tec": "李灏",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男乒",
        "tec": "郝策",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "搏击"
      },
      {
        "sub": "轮滑",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "搏击"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵明明张莉静",
      "week": "11-15周",
      "add": "教学楼C座114教务"
    }
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "马婷婷",
      "week": "1-6,8-17单周",
      "add": "教学楼C座111教务"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "25新能源1-1",
        "tec": "文菲",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25新能源2-1",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25新能源1-3",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      }
    ],
    {
      "sub": "分析化学",
      "tec": "田甜",
      "week": "1-6,8-15周",
      "add": "实训楼F座301信息"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
